module.exports = __webpack_public_path__ + "img/semel.9b957b92.png";